module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.2022/img/InterstitialBlobs.png"